/* Lumiwee PDP enhancements: description "Read more" + section scroll reveal.
 * Loaded (deferred) on product pages only. No dependencies. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clampDescription() {
    const desc = document.querySelector('.product-details .text-block.rte');
    if (!desc || desc.dataset.lwDesc) return;
    desc.dataset.lwDesc = '1';

    const inner = document.createElement('div');
    inner.className = 'lw-desc__inner';
    while (desc.firstChild) inner.appendChild(desc.firstChild);
    desc.appendChild(inner);
    desc.classList.add('lw-desc');

    // Only clamp when there is meaningfully more text than the preview shows.
    const lineHeight = parseFloat(getComputedStyle(inner).lineHeight) || 24;
    if (inner.scrollHeight < lineHeight * 7) return;

    const id = 'lw-desc-' + Math.random().toString(36).slice(2, 8);
    inner.id = id;
    desc.classList.add('lw-desc--clamped');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lw-desc__toggle';
    btn.setAttribute('aria-controls', id);
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    btn.addEventListener('click', () => {
      const open = desc.classList.toggle('lw-desc--clamped') === false;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Show less' : 'Read more';
      if (!open) desc.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    desc.appendChild(btn);
  }

  function revealSections() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll('main .cln-sec:not(:has(.lw-row)), main .lw-rows__eyebrow, main .lw-row');
    if (!targets.length) return;
    document.documentElement.classList.add('lw-reveal-on');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px 15% 0px', threshold: 0 }
    );
    targets.forEach((el) => {
      // Anything already on screen shows immediately — no flash of hidden content.
      const r = el.getBoundingClientRect();
      el.classList.add('lw-reveal');
      if (r.top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  function init() {
    clampDescription();
    revealSections();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
